<div class="se-time-picker-main-container" [class.se-datetime-no-highlight]="!highlightBackgroundEnabled()">
    <mat-form-field [ngClass]="gridClass() !== '' ? gridClass() : 'se-form-field'" style="max-width:150px;" appearance="{{appearance()}}">
        @if(isWithLabel()){
        <mat-label>{{ label() }}</mat-label>
        }
        <input matInput #seTimePickerInput se-autofocus
               [class.se-datetime-picker-time-picker-error]="isOnError"
               [matTimepicker]="seTimePickerInput_Time"
               [formControl]="timeControl"
               [placeholder]="timeFormat()"
               [required]="required()" />
        <mat-timepicker interval="15min" #seTimePickerInput_Time class="customPanelClass()"
                        (opened)="onOpenTime()"
                        (selected)="onTimeChanging($event)" />
        @if(showIcon()){
        <mat-timepicker-toggle matIconSuffix [for]="seTimePickerInput_Time">
            <mat-icon matTimepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-timepicker-toggle>
        }
    </mat-form-field>
</div>
